(function () {
  function initFeatured(section) {
    var viewport = section.querySelector(".featured__list-wrap");
    var track = viewport && viewport.querySelector(".featured__track");
    var sourceList = track && track.querySelector(".featured__list");
    if (!viewport || !track || !sourceList) return;

    var clone = sourceList.cloneNode(true);
    clone.classList.add("featured__list--clone");
    clone.setAttribute("aria-hidden", "true");
    track.appendChild(clone);

    var debounceId = null;

    function needsMarquee() {
      var items = sourceList.querySelectorAll(".featured__item");
      if (!items.length) return false;

      var gap = parseFloat(getComputedStyle(sourceList).columnGap) || 0;
      var total = 0;

      items.forEach(function (item) {
        total += item.getBoundingClientRect().width;
      });

      total += gap * (items.length - 1);
      return total > viewport.getBoundingClientRect().width + 1;
    }

    function update() {
      section.classList.toggle("featured--marquee", needsMarquee());
    }

    function scheduleUpdate() {
      if (debounceId) clearTimeout(debounceId);
      debounceId = setTimeout(update, 200);
    }

    var imgs = sourceList.querySelectorAll("img");
    var pending = 0;

    function onImageReady() {
      if (--pending <= 0) update();
    }

    imgs.forEach(function (img) {
      if (!img.complete || img.naturalWidth === 0) {
        pending++;
        img.addEventListener("load", onImageReady, { once: true });
        img.addEventListener("error", onImageReady, { once: true });
      }
    });

    if (pending === 0) update();

    window.addEventListener("resize", scheduleUpdate);
    window.addEventListener("load", scheduleUpdate);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  }

  document.querySelectorAll(".featured").forEach(initFeatured);
})();
